import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import WhoIWorkWith from "@/components/site/WhoIWorkWith";
import WhatIDo from "@/components/site/WhatIDo";
import WhyProjectBased from "@/components/site/WhyProjectBased";
import HowItWorks from "@/components/site/HowItWorks";
import AfterState from "@/components/site/AfterState";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function LandingPage() {
  return (
    <main data-testid="landing-page" className="bg-sand text-deep-lake">
      <Nav />
      <Hero />
      <WhoIWorkWith />
      <WhatIDo />
      <WhyProjectBased />
      <HowItWorks />
      <AfterState />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
